import styled from "styled-components";

export const InfoSec = styled.div`
  padding: 100px 0px;
  background: ${({ light }) => (light ? "white" : "#0a0806")};

  @media screen and (max-width: 960px) {
    padding: 80px 0px;
  }
`;

export const InfoContainer = styled.div`
  max-width: 1400px;
  margin-right: auto;
  margin-left: auto;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
  margin: 0px -15px -15px -15px;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};

  @media screen and (max-width: 960px) {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const Links = styled.a`
  text-decoration: none;
  color: ${({ light }) => (light ? "#e53935" : "#009688")};
`;

export const InfoColumn = styled.div`
  margin-bottom: 25px;
  margin-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 960px) {
    margin-bottom: 30px;
    max-width: 100%;
    flex-basis: 100%;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoSecGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 180px);
  gap: 10px;
  width: 80%;
  justify-content: center;
`;

export const InfoSecSkill = styled.div`
  display: flex;
`;

export const InfoSecImg = styled.div``;

export const InfoSecText = styled.p``;

export const TopLine = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ light }) => (light ? "#535b61" : "#8ae0db")};
  font-size: 35px;
  letter-spacing: 1.4px;
  margin-bottom: 15px;
  font-weight: bold;

  @media screen and (max-width: 960px) {
    font-size: 25px;
  }
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  display: flex;
  justify-content: center;
  text-align: center;
  color: ${({ light }) => (light ? "#e53935" : "#f7f8fa")};

  @media screen and (max-width: 960px) {
    font-size: 35px;
  }
`;

export const Subtitle = styled.p`
  text-align: center;
  max-width: 540px;
  margin-bottom: 35px;
  font-size: 20px;
  line-height: 24px;
  color: ${({ light }) => (light ? "#45484a" : "#a9b3c1")};

  @media screen and (max-width: 960px) {
    font-size: 15px;
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImgWrapper = styled.div`
  max-width: 500px;
  display: flex;
  justify-content: ${({ start }) => (start ? "flex-start" : "center")};
  background: ${({ light }) =>
    light
      ? "linear-gradient(rgb(236, 68, 54, 0.6), rgb(73, 126, 118, 0.8))"
      : "linear-gradient(rgb(73, 126, 118, 0.6), rgb(73, 126, 118, 0.8))"};
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 500px;
  border-radius: 10px;
`;
